import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/listService";
const store = {};
const mutations = {
    SET_LIST_LIST(state, posts) {
        state.listList = posts;
        state.listListIsLoading = false;
    },
    GET_LIST_ITEM(state, posts) {
        state.listItem = posts.listItemList;
        state.listListIsLoading = false;
    },
    SAVE_LIST_LIST(state, posts) {
        state.listList = posts;
        state.listListIsLoading = false;
    },
};

const state = {
    listListIsLoading: false,
    listList: [],
    listItem: {}
};

const getters = {};

const actions = {
    getListList({ commit }) {
        state.listListIsLoading = true;
        axios
            .get(baseUri + '/GetList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_LIST_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getListListItem({ commit }, { LisId, Type }) {
        state.listListIsLoading = true;
       return axios
            .get(baseUri + '/GetListItemList', { params: { LisId, Type } })
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_LIST_ITEM',res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res.data;
            });
    },
    saveListList({ commit }, data ) {
        var formData = new FormData();
        formData.append("updates", JSON.stringify(data.updates));
        formData.append("remove", JSON.stringify(data.remove));
        formData.append("insert", JSON.stringify(data.insert));
        axios
            .post(baseUri + '/UpdateListList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_LIST_LIST', res.data.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}